// Microsoft Clarity must never record staff. public/index.html skips the
// Clarity tag when this flag is present, so once anyone signs in as an admin
// in a browser, that browser is never recorded again (from the next page
// load). Clarity has no documented "stop" call, so the session in which the
// flag is first set is tagged staff=1 instead — filter on it in Clarity.
export const STAFF_BROWSER_KEY = "tpw_staff";

export function markStaffBrowser() {
  try {
    localStorage.setItem(STAFF_BROWSER_KEY, "1");
    const w = window as unknown as {
      clarity?: (...args: unknown[]) => void;
    };
    w.clarity?.("set", "staff", "1");
  } catch {
    // storage blocked (private mode) — nothing to do
  }
}
